import * as React from 'react'
import { IconWrapper } from '../IconWrapper'
import { IconProps } from '../iconConstants'

export const EditIcon = ({ title, titleId, ...props }: IconProps) => (
    <IconWrapper {...props}>
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="1em"
            height="1em"
            fill="none"
            viewBox="0 0 24 24"
            aria-labelledby={titleId}
            {...props}
        >
            {title ? <title id={titleId}>{title}</title> : null}
            <path
                fill="currentColor"
                d="m4.5 19.5-.474-.158a.5.5 0 0 0 .632.632L4.5 19.5ZM6 15l-.354-.354a.5.5 0 0 0-.12.196L6 15Zm9.5-9.5.354-.354-.354-.353-.354.353.354.354Zm3 3 .354.354.353-.354-.353-.354-.354.354ZM9 18l.158.474a.5.5 0 0 0 .196-.12L9 18Zm-4.026 1.658 1.5-4.5-.948-.316-1.5 4.5.948.316Zm1.38-4.304 9.5-9.5-.708-.708-9.5 9.5.708.708Zm8.792-9.5 3 3 .708-.708-3-3-.708.708Zm3 2.292-9.5 9.5.708.708 9.5-9.5-.708-.708Zm-9.304 9.38-4.5 1.5.316.948 4.5-1.5-.316-.948Z"
            />
            <path
                fill="currentColor"
                d="m15.5 5.5-.354-.354-.353.354.353.354.354-.354Zm3 3-.354.354.354.353.354-.353L18.5 8.5Zm.586-.586.353.354-.353-.354Zm0-2.828-.354.353.354-.353Zm-3.94.768 3 3 .708-.708-3-3-.708.708Zm3.708 3 .585-.586-.707-.707-.586.585.708.708Zm.585-4.122-.171-.171-.707.707.171.171.707-.707Zm-3.707-.171-.586.585.708.708.585-.586-.707-.707Zm3.536 0a2.5 2.5 0 0 0-3.536 0l.707.707a1.5 1.5 0 0 1 2.122 0l.707-.707Zm.171 3.707a2.5 2.5 0 0 0 0-3.536l-.707.707a1.5 1.5 0 0 1 0 2.122l.707.707Z"
            />
            <path stroke="currentColor" strokeLinejoin="round" d="m6.5 14.5 3 3" />
        </svg>
    </IconWrapper>
)
